window.addEventListener('newLang', () => {
  document.getElementById('homeButton').href = `/?lang=${window.lang}`;
});
